import { render } from "./edit.vue?vue&type=template&id=54b2dec8&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=54b2dec8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b2dec8"],['__file',"Scripts/components/pages/usersettings/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54b2dec8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54b2dec8', __exports__)) {
    api.reload('54b2dec8', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=54b2dec8&scoped=true", () => {
    api.rerender('54b2dec8', render)
  })

}


export default __exports__